'use client';

import React, { memo } from 'react';
import Image from 'next/image';

interface MoneziteLogoProps {
  height?: number;
  className?: string;
  onClick?: () => void;
  showWordmark?: boolean;
  whiteText?: boolean;
}

const MoneziteLogo = memo(function MoneziteLogo({
  height = 40,
  className = '',
  onClick,
  showWordmark = false,
  whiteText = false,
}: MoneziteLogoProps) {
  const mobileHeight = Math.round(height * 0.7);

  return (
    <div
      className={`flex items-center gap-0 ${className}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
      aria-label="Monezite — Monetize Your Ideas"
      role="img"
    >
      {/* Coin logo acts as the "M" — Mobile */}
      <Image
        src="/assets/images/ChatGPT_Image_Aug_8__2026__08_38_46_PM-1786214499973.png"
        alt="Monezite blue coin logo with M"
        width={mobileHeight}
        height={mobileHeight}
        className="block sm:hidden"
        style={{ width: mobileHeight, height: mobileHeight, objectFit: 'contain' }}
        priority
      />
      {/* Coin logo acts as the "M" — Desktop */}
      <Image
        src="/assets/images/ChatGPT_Image_Aug_8__2026__08_38_46_PM-1786214499973.png"
        alt="Monezite blue coin logo with M"
        width={height}
        height={height}
        className="hidden sm:block"
        style={{ width: height, height: height, objectFit: 'contain' }}
        priority
      />
      {/* Wordmark: "ONE" in deep navy/black, "ZITE" in cyan — no leading "M" */}
      <span
        style={{ fontWeight: 700, letterSpacing: '0.04em', lineHeight: 1 }}
        className="font-bold tracking-wide select-none text-xs sm:text-base md:text-lg"
      >
        <span style={{ color: whiteText ? '#ffffff' : '#0A1628' }}>ONE</span>
        <span style={{ color: whiteText ? '#06B6D4' : '#06B6D4' }}>ZITE</span>
      </span>
    </div>
  );
});

export default MoneziteLogo;
